import React, { Component } from 'react';
import Loading from '../../../../components/Loading';
import ReactModal from '../../../../components/Modal';
import AiTrackingAdd from '../../create';
import { withTranslation } from 'react-i18next';

class AddKeywordModal extends Component {
    constructor() {
        super();

        this.submitButtonRef = React.createRef(null);
        this.onAdd = this.onAdd.bind(this);
        this.onChangeLoading = this.onChangeLoading.bind(this);
        this.onChangeCanSubmit = this.onChangeCanSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.modalBodyRef = React.createRef(null);

        this.state = {
            isLoading: false,
            // The form starts incomplete (no platform picked), and reports back through
            // onChangeCanSubmit as soon as it is fillable.
            canSubmit: false,
        };
    }

    onAdd() {
        if (this.submitButtonRef.current) {
            this.submitButtonRef.current?.click();
        }
    }

    onChangeLoading(bool) {
        this.setState({
            isLoading: bool,
        });
    }

    // The real submit button lives inside AiTrackingAdd and is hidden here — it is clicked through
    // submitButtonRef. A disabled button eats that click without a word, so this footer button
    // mirrors the form's own state instead of looking clickable while doing nothing.
    onChangeCanSubmit(canSubmit) {
        this.setState({
            canSubmit,
        });
    }

    onSubmit() {
        this.onChangeLoading(false);
        this.props.onClose();
    }

    render() {
        const { t } = this.props;

        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="ai-tracking-edit-keyword-container  ai-tracking-modal"
                onClose={this.props.onClose}
            >
                <h3>{t('ai_tracking.keyword_manager.edit_keyword.add_prompt')}</h3>
                <div
                    ref={this.modalBodyRef}
                    className="ai-tracking-edit-keyword-container-body ai-tracking-modal-view px-12"
                >
                    <AiTrackingAdd
                        prompts={this.props.prompts}
                        submitButtonRef={this.submitButtonRef}
                        onChangeLoading={this.onChangeLoading}
                        onChangeCanSubmit={this.onChangeCanSubmit}
                        onSubmit={this.onSubmit}
                        defaultSelectedProject={this.props.projectId}
                        isModal
                        modalBodyRef={this.modalBodyRef}
                    />
                </div>
                <div className="btn-wrapper ai-tracking-modal-footer">
                    <button
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                        disabled={this.state.isLoading || !this.state.canSubmit}
                        onClick={this.onAdd}
                    >
                        <span style={{ marginRight: '5px' }}>
                            {t('ai_tracking.add_keyword.submit')}
                        </span>
                        {this.state.isLoading && <Loading onlyPreloader />}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={this.props.onClose}
                        style={{ lineHeight: 'unset' }}
                    >
                        {t('ai_tracking.keyword_manager.edit_keyword.close')}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(AddKeywordModal);
